let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7ouuO")).then(() => parcelRequire('6S3N0'));